module.exports = __webpack_public_path__ + "static/img/banner.d944ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beginnersOnly/banner.png
// module id = dcsA
// module chunks = 0